<template>
  <div class="adviser-com">
    <div class="avatar">
      <img :src="info.avatar" alt="">
    </div>
    <div class="info">
      <div class="name">{{ info.realName }}</div>
      <!-- <div class="project">{{ info.projectName }}</div> -->
      <div class="phone" @click="copy(info.phone)">
        <img style="width: 16px; height: 16px; vertical-align: -1px" alt="icon" src="https://xfjoss.coli688.com/pc-images/adviser-phone.png"/>
        {{ info.phone }}
        <!-- <i class="el-icon-document-copy" /> -->
        <img style="width: 15px; height: 15px; vertical-align: -1px" alt="icon" src="https://xfjoss.coli688.com/pc-images/adviser-copy-phone.png"/>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'adviser-com',
  props: {
    info: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
    }
  },
  methods: {
    copy (data) {
      let input = document.createElement('input')
      input.value = data
      input.id = 'creatDom'
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$message({
        message: '复制手机号码成功',
        type: 'success'
      });
    }

  }
}
</script>
<style lang="scss" scoped>
.adviser-com{
  width: 350px;
  height: 85px;
  display: flex;
  justify-content: flex-start;
  align-items: top;
  .avatar{
    img{
      width: 60px;
      height: 60px;
      border-radius: 50%;
      border: 1px solid rgba($color: #000000, $alpha: 0.1);
    }
  }
  .info{
    margin-left: 16px;
    .name{
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      @include font20(500, #333);
    }
    .project{
      @include font14(400, #9399A5);
      margin-top: 10px;
    }
    .phone{
      cursor: pointer;
      @include font18(500, #BEA36D);
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      margin-top: 8px;
      .el-icon-document-copy {
        @include font18(400, black);
      }
    }
  }
}
</style>
